import { GET_AFFILIATES, VALIDATE_AFFILIATE_BMI } from "../../@dhn/shared/queries/affiliate";
import { useEffect, useState } from "react";
import { useApolloClient, useMutation, useQuery } from "@apollo/react-hooks";
import { useToasts } from "react-toast-notifications";
import { isEmpty, omit, uniqBy } from "lodash";
import {
  GET_MEDICAL_STAFF,
  GET_MEDICINES,
  START_PROCESS_AUTHORIZATION,
  MEDICINES_VALIDATION,
  GET_CANCELATION_REASONS,
  CANCEL_AUTHORIZATION,
  GET_BRANCH_ARS,
  VALIDATE_AFFILIATE_UNIVERSAL,
  GET_AFFILIATE_DHN,
  GET_PERSON_REGISTRY,
  SAVE_PERSON_REGISTRY,
  GET_BRANCH_OFFICES_FOR_USER_CALL_CENTER,
  GET_RECIPE_TYPE,
  GET_RECIPE_VALIDITY,
  DATA_OFFERS,
  GET_OPTIONS,
  // GET_DATA_REPORT_PARTIAL_DISPATCH,
} from "./queries";
// import axios from "axios";
import moment from "moment";
import { onError } from "@dhn/shared/utils";
import { fetchCompanyInfo } from "@dhn/shared/company-info";
import { awardedOffersReportPdf } from "./reports/awardedOffersReportPdf";
import { reportPartialDispatch } from "./reports/reportPartialDispatch";
import { aps, bmiRepublicaDominicana, cmd, futuro, monumental, primeraHumano, reservas, seguroCarnet, seguroReservas, senasa, universal } from "../../assets/img/brand";
import idoppril from "../../assets/img/brand/idopril.svg";
import { abelGonzales } from "../../assets/img/brand/abelGonzales";
import { resetProductPrice } from "./product-pricing";

const initialState = {
  validated: false,
  show: false,
  show2: false,
  productSelected: [],
  validated2: false,
  loadingProcess: false,
  affiliateModalUniversal: false,
  affiliateUniversal: [],
  referalNumber: "",
  products2: [],
  saveNewPersonRegistry: false,
  toggleDoc: false,
  keyDoc: 1,
  showMessageError: false,
  recipeTypeOption: [],
  recipeTypeSelected: {},
  dataOffers: [],
  viewPage: 1,
  offerSelected: {},
  periodSelected: {},
};

const logoArs = {
  1: {
      0: aps,
      1: aps,
      2: aps,
      3: aps
    },
  4: {
      0: futuro,
  },
  7: {
      0: abelGonzales,
      3: abelGonzales,
  },
  9: {
      0: universal,
      1: universal,
      2: universal,
      3: universal,
      4: universal,
  },
  11: {
       0: bmiRepublicaDominicana,
       1: bmiRepublicaDominicana,
       2: bmiRepublicaDominicana,
       3: bmiRepublicaDominicana,
  },
  15:{
       0:cmd,
       1:cmd,
       2:cmd,
       3:cmd,
  },
  16:{
       0: idoppril,
  },
  17:{
       0: monumental,
       1: monumental,
       2: monumental,
  },
  18:{
       0:senasa,
       1:senasa,
       2:senasa,
       3:senasa,
  },
  19:{
       0: reservas,
       1: reservas,
       2: reservas,
       3: reservas,
       4: reservas,
  },
  20:{
       0: seguroReservas,
       1: seguroCarnet,

  },
  21:{
       0: primeraHumano,
       1: primeraHumano
  },
};

export const useActions = ({loggedUserData}) => {
  const [state, setState] = useState(initialState);
  const [datas, setData] = useState({});
  const [dataAuth, setDataAuth] = useState({});
  const [isLoadingAffiliateUniversal, setValue] = useState(false);
  const [isLoading, setLoading] = useState(false);
  const [isVerifyingRecipe, setIsVerifyingRecipe] = useState(false);
  const [inputName, setInputName] = useState("");
  const { addToast } = useToasts();
  const client = useApolloClient();
  const [updateMutate] = useMutation(START_PROCESS_AUTHORIZATION);
  const [cancelAuth] = useMutation(CANCEL_AUTHORIZATION);
  const [savePerson] = useMutation(SAVE_PERSON_REGISTRY);
  const [comboBranches, setComboBranches] = useState([]);
  const [branchSelected, setBranchSelected] = useState(null);
  const [optionsData, setOptionsData] = useState([]);
  const [isOpenPreautorizationModal, setIsOpenPreautorizationModal] = useState(false);

  const { data: reasonCancelation, loading: isLoadingReasonCancelation } =
    useQuery(GET_CANCELATION_REASONS, {
      fetchPolicy: "network-only",
      variables: {
        filters: {
          operator: "AND",
          filters: [
            {
              op: "EQ",
              field: "CancelationReasonEntity.enabled",
              values: ["true"],
            },
          ],
        },
      },
    });

  const { data: { options } = [], loading: loadingOptions } = useQuery(
    GET_OPTIONS,
    {
      fetchPolicy: "network-only",
    }
  );

  const { data: branches, loading: loadingBranches } = useQuery(
    GET_BRANCH_OFFICES_FOR_USER_CALL_CENTER,
    {
      fetchPolicy: "network-only",
    }
  );

  const { data: arsList, loading: arsLoading } = useQuery(GET_BRANCH_ARS, {
    fetchPolicy: "network-only",
  });

  const { data: dataRecipeType } = useQuery(GET_RECIPE_TYPE, {
    fetchPolicy: "network-only",
    variables: {
      where: {
        enabled: true,
        // arsId
      },
    },
  });

  const { data: { offers } = {}, loading: loadingOffers } = useQuery(
    DATA_OFFERS,
    {
      skip: !(state?.viewPage === 5),
      fetchPolicy: "network-only",
      variables: {
        relations: [
          "claimsOffersProcess",
          "claimsOffersProcess.branchOffice",
          "claimsOffersProcess.arsEntity",
          "claimsOffersProcess.medicine",
          "claimsOffersProcess.line",
        ],
        where: {
          enabled: true,
          arsId: state?.ars?.arsId,
          layoutClaim: true,
        },
      },
    }
  );

  const onSelectArs = (ars, view = 1) => {
    if (view === 5)
      return setState({
        ...state,
        offerSelected: {},
        dataOffers: [],
        ars,
        viewPage: view,
      });

    setState({
      ...initialState,
      ars: ars,
      arsList: arsList.arses,
      reasonsCancelation: reasonCancelation.reasons,
      recipeTypeOption: dataRecipeType?.recipeTypes,
    });
    setData({});
    // setState(s => ({ ...s, ars: ars }));
  };

  const onChange = (key, value) => {
    if (key === "lineSelected" && Object.keys(state.periodSelected).length)
      return setState((prev) => ({
        ...prev,
        periodSelected: {},
        [key]: value,
      }));
    setState((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const onSelectDoc = (doc) => {
    setState((s) => ({ ...s, documentType: doc, documentValue: "" }));
  };

  const onHandleDoc = (value) => {
    setState((s) => ({ ...s, documentValue: value }));
  };

  const getLogo = () => {
    const logos = logoArs[state.ars?.arsId];
    if (!logos) return null;

    // El logo puede variar segun el tipo de identificacion elegido
    return logos[state.documentType?.key] || logos[0] || null;
  };


  const toggleDropDown = (toggle, key) => {
    key
      ? setState((s) => ({
          ...s,
          toggleDoc: toggle,
          keyDoc: key,
          cedPicker: "",
        }))
      : setState((s) => ({ ...s, toggleDoc: toggle }));
  };

  const validateData = (data, isReferal = false) => {
    if (isEmpty(data.ars)) {
      addToast("Debe seleccionar una aseguradora.", {
        appearance: "error",
        autoDismiss: true,
      });
      return null;
    }
    if (isEmpty(data.documentType)) {
      addToast("Debe seleccionar un Tipo de Identificación.", {
        appearance: "error",
        autoDismiss: true,
      });
      return null;
    }
    if (isEmpty(data.documentValue)) {
      addToast("Debe llenar campo de No. de Identificación.", {
        appearance: "error",
        autoDismiss: true,
      });
      return null;
    }

    if (isReferal && !state?.referalNumber?.trim()) {
      addToast(
        "Favor Colocar Número de Referimiento-Receta en el Campo: Plan Preventivo.",
        { appearance: "error", autoDismiss: true }
      );
      return null;
    }

    if (isEmpty(data.staff) && data.step === 2) {
      addToast("Debe llenar campo de Médico.", {
        appearance: "error",
        autoDismiss: true,
      });
      return null;
    }
    if (isEmpty(data.cedPicker?.trim()) && data.step === 2) {
      addToast("Debe llenar campo de Cédula.", {
        appearance: "error",
        autoDismiss: true,
      });
      return null;
    }
    if (data.cedPicker?.length < 11 && data.keyDoc === 1 && data.step === 2) {
      addToast("Debe digitar una cédula válida.", {
        appearance: "error",
        autoDismiss: true,
      });
      return null;
    }
    if (!data.recipeTypeSelected?.id && data.step === 2) {
      addToast("Seleccionar Tipo de Receta.", {
        appearance: "error",
        autoDismiss: true,
      });
      return null;
    }
    if (data.recipeDate === undefined && data.step === 2) {
      addToast("Debe llenar campo de Fecha de Receta.", {
        appearance: "error",
        autoDismiss: true,
      });
      return null;
    }
    if (isEmpty(data.telephone) && data.step === 2) {
      addToast("Debe llenar campo de Teléfono.", {
        appearance: "error",
        autoDismiss: true,
      });
      return null;
    }
    if (data.telephone?.length < 10 && data.step === 2) {
      addToast("Debe digitar un número de teléfono válido.", {
        appearance: "error",
        autoDismiss: true,
      });
      return null;
    }
    const codeTel = data.telephone?.slice(0, 3);
    if (
      codeTel !== "809" &&
      codeTel !== "829" &&
      codeTel !== "849" &&
      data.step === 2
    ) {
      addToast("Número de teléfono NO válido.", {
        appearance: "error",
        autoDismiss: true,
      });
      return null;
    }
  };

  const onVerifyAffiliate = async (isReferal) => {
    if (validateData(state, isReferal) === null) return;
    try {
      setLoading(true);
      const payload = {
        arsid: state.ars.arsId,
        tipodoc: state.documentType.key,
        identificacion: state.documentValue,
        referalNumber: state.referalNumber,
      };
      const { data } = await client.query({
        query: GET_AFFILIATES,
        fetchPolicy: "network-only",
        variables: { where: payload },
      });
      const affiliates = data?.getAffiliates || [];
      const error = affiliates.find((affiliate) => [1005, 1003, 2, 5].includes(affiliate?.ErrorNumber));
      if (error) {
        addToast(error.ErrorMessage, { appearance: "error", autoDismiss: true });
        return;
      }
      if (!affiliates.length) {
        addToast("Afiliado no encontrado.", { appearance: "error", autoDismiss: true });
        return;
      }
      if (affiliates.length > 1) {
        setState((e) => ({ ...e, affiliateModalUniversal: true, affiliateUniversal: affiliates }));
        return;
      }
      setData(affiliates[0]);
      setState((e) => ({ ...e, validated: true, step: 2 }));
    } catch (error) {
      onError(error, addToast);
    } finally {
      setLoading(false);
    }
  };

  const onSelectAffiliate = async (affiliate) => {
    if (![9, 11].includes(state.ars.arsId)) {
      setData(affiliate);
      setState((e) => ({ ...e, validated: true, step: 2, affiliateModalUniversal: false, affiliateUniversal: [] }));
      return;
    }
    try {
      setValue(true);
      const { data } = await client.query({
        query: state.ars.arsId === 11 ? VALIDATE_AFFILIATE_BMI : VALIDATE_AFFILIATE_UNIVERSAL,
        fetchPolicy: "network-only",
        variables: {
          where: {
            arsid: state.ars.arsId,
            tipodoc: state.documentType.key,
            identificacion: state.documentValue,
            referalNumber: state.referalNumber,
            afiliateUniversal: omit(affiliate, [
              "programPyPList",
              "UUIDIdentifier",
              "sessionIdPrimera",
              "coveragePercentage",
              "dependentNumber",
              "eligibilityStatus",
              "effectiveDate",
              "expirationDate",
            ]),
          },
        },
      });
      data && setData(data.item);
      data &&
        setState((e) => ({
          ...e,
          validated: true,
          step: 2,
          affiliateModalUniversal: false,
          affiliateUniversal: [],
        }));
    } catch (error) {
      setState((e) => ({
        ...e,
        affiliateModalUniversal: false,
        affiliateUniversal: [],
      }));
      onError(error, addToast);
    } finally {
      setValue(false);
    }
  };

  const onCloseAffiliateModal = () =>
    setState((e) => ({
      ...e,
      affiliateModalUniversal: false,
      affiliateUniversal: [],
    }));

  const handleStaffChange = (value, { action }) => {
    if (action === "select-option") {
      setState((e) => ({ ...e, staff: value }));
    }
  };

  const loadMedicalStaffs = async (value, callback) => {
    if (value.length < 3) return callback([]);
    const {
      data: { items },
    } = await client.query({
      query: GET_MEDICAL_STAFF,
      fetchPolicy: "network-only",
      variables: {
        where: {
          arsid: state.ars.arsId,
          name: value,
        },
      },
    });
    callback(
      uniqBy(items, "fullname").map((i) => ({
        value: i.id,
        label: i.fullname,
        code: i.codigo,
      }))
    );
  };

  const handleInputDate = (dateValue) => {
    setState((e) => ({ ...e, recipeDate: dateValue }));
  };

  const handleInputs = ({ key, value }) =>
    setState((e) => ({ ...e, [key]: value }));

  const onVerifyRecipeData = async () => {
    if (validateData(state) === null) return;

    setIsVerifyingRecipe(true);
    try {

      //#region 1.Buscar tabla de Registro de persona
      const { data: personData } = await client.query({
        query: GET_PERSON_REGISTRY,
        fetchPolicy: "network-only",
        variables: {
          where: {
            identificationCard: state.cedPicker,
          },
        },
      });
      if (!isEmpty(personData.getPersonRegistry)) {
        const { name, lastName, lastName2 } = personData.getPersonRegistry;
        const affiliate = {
          Nombres: name,
          Apellido1: lastName,
          Apellido2: lastName2,
        };
        return await onValidateRecipeDate(affiliate);
      }
      //#endregion

      //#region 2.Buscar afiliado por DHN
      const { data: affiliateDHN } = await client.query({
        query: GET_AFFILIATE_DHN,
        fetchPolicy: "network-only",
        variables: {
          where: {
            identificationCard: state.cedPicker,
          },
        },
      });
      if (!isEmpty(affiliateDHN.affiliate)) {
        const { firstName, middleName, lastName, lastName2, dateOfBirth } =
          affiliateDHN.affiliate;
        const affiliate = {
          Nombres: `${firstName} ${middleName}`,
          Apellido1: lastName,
          Apellido2: lastName2,
        };

        const resp = await savePersonRegistry({
          name: `${firstName} ${middleName}`,
          lastName,
          lastName2,
          identificationCard: state.cedPicker,
          dateOfBirth: new Date(dateOfBirth),
        });

        if (!resp)
          return addToast("Ha ocurrido un error. Favor intentarlo nuevamente.", {
            appearance: "error",
            autoDismiss: true,
          });

        return await onValidateRecipeDate(affiliate);
      }
      //#endregion

    //#region 3.Buscar persona API Cedula ----- Ahora mismo no está funcionando por eso está comentado
    // const { data } = await axios(`https://api.adamix.net/apec/cedula/${state.cedPicker}`);

    // if ( data.ok ) {

    //     const resp = await savePersonRegistry({
    //         name: data.Nombres,
    //         lastName: data.Apellido1,
    //         lastName2: data.Apellido2,
    //         identificationCard: state.cedPicker,
    //         dateOfBirth: new Date( data.FechaNacimiento )
    //     });

    //     if ( !resp ) return addToast('Ha ocurrido un error. Favor intentarlo nuevamente.', { appearance: 'error', autoDismiss: true });

    //     return await onValidateRecipeDate( data )
    // }
    //#endregion

      addToast(
        "Documento no encontrado. Favor digitar el nombre completo de quien recoge medicamentos.",
        { appearance: "warning", autoDismiss: true }
      );
      setState((s) => ({ ...s, saveNewPersonRegistry: true }));
    } catch (error) {
      onError(error, addToast);
    } finally {
      setIsVerifyingRecipe(false);
    }
  };

  const onHandleClickCedula = () =>
    setState((s) => ({ ...s, saveNewPersonRegistry: false }));

  const savePersonRegistry = async (affiliate) => {
    try {
      const payload = {
        name: affiliate.name,
        lastName: affiliate.lastName,
        lastName2: affiliate.lastName2,
        identificationCard: affiliate.identificationCard,
        dateOfBirth: affiliate.dateOfBirth,
      };

      const { data } = await savePerson({
        variables: {
          data: payload,
        },
      });

      if (!data.resp.isOk) return false;

      return true;
    } catch (error) {
      console.error(error);
    }
  };

  const onSaveWeirdIdentification = async () => {
    if (inputName.length < 3)
      return addToast("Debe colocar un nombre válido.", {
        appearance: "error",
        autoDismiss: true,
      });

    const resp = await savePersonRegistry({
      name: inputName.trim(),
      lastName: "",
      lastName2: "",
      identificationCard: state.cedPicker,
      dateOfBirth: new Date(),
    });

    if (!resp)
      return addToast("Ha ocurrido un error. Favor intentarlo nuevamente.", {
        appearance: "error",
        autoDismiss: true,
      });

    const isOk = await onValidateRecipeDate({
      Nombres: inputName,
      Apellido1: "",
      Apellido2: "",
    });

    if (isOk)
      return addToast("Cédula registrada exitosamente.", {
        appearance: "success",
        autoDismiss: true,
      });
  };

  const onValidateRecipeDate = async (affiliate) => {
    const { data: data2 } = await client.query({
      query: GET_RECIPE_VALIDITY,
      fetchPolicy: "network-only",
      variables: {
        where: {
          arsId: state.ars.arsId,
          recipeTypeId: state.recipeTypeSelected?.id,
        },
      },
    });
    //Validacion de la fecha
    // const { data: data2 } = await client.query({
    //     query: GET_DAYS_CONTINUOUS_PRESCRIPTIONS,
    //     fetchPolicy: 'network-only',
    //     variables: {
    //         where: {
    //             arsid: state.ars.arsId
    //         }
    //     }
    // })
    // const days = state.isContinuousUse ? data2.item.days > 0 ? data2.item.days : 30 : 30

    if (!data2?.recipeValidity[0]?.validity) {
      addToast("ERROR: Configurar vigencia del tipo de Receta Seleccionada.", {
        appearance: "error",
        autoDismiss: true,
      });
      return false;
    }

    const days = data2.recipeValidity[0].validity;
    const fechaActual = moment().format("YYYY-MM-DD");
    const fechaRestada = moment().add(-days, "d").format("YYYY-MM-DD");
    const fechaCapturada = moment(state.recipeDate).format("YYYY-MM-DD");

    const { Nombres, Apellido1, Apellido2 } = affiliate;
    if (fechaCapturada >= fechaRestada && fechaCapturada <= fechaActual) {
      setState((e) => ({
        ...e,
        namePicker: `${Nombres} ${Apellido1} ${Apellido2}`,
        validated2: true,
        continuousPrescription: data2.recipeValidity[0].validity,
        isContinuousUse: data2.recipeValidity[0].id === 3 ? true : false,
      }));
      return true;
    }
    addToast("Receta fuera del rango por la fecha establecida", {
      appearance: "error",
      autoDismiss: true,
    });
    return false;
  };

  const handleMedicineChange = (value, { action }) => {
    if (action === "select-option") {
      setState((e) => ({ ...e, products: value }));
      if (value.isDetailing) {
        setState((e) => ({
          ...e,
          products2: [
            {
              name: value.name,
              price: value.price,
              id: value.id,
              //   isDetailing: value.isDetailing,
              isDetailing: false,
              rdfCode: value.rdfCode,
              codes: value.codes,
              insuranceCode: value.insuranceCode,
              brandName: value.brandName,
              concentracionName: value.concentracionName,
              contentCant: value.contentCant,
              shapeName: value.shapeName,
              moleculeMedicines: value.moleculeMedicines,
            },

            {
              name: value.nameDetailing,
              price: value.retailPrice,
              id: value.id,
              isDetailing: value.isDetailing,
              rdfCode: value.rdfCode,
              codes: value.codes,
              insuranceCode: value.insuranceCode,
              brandName: value.brandName,
              concentracionName: value.concentracionName,
              contentCant: value.contentCant,
              shapeName: value.shapeName,
              moleculeMedicines: value.moleculeMedicines,
            },
          ],
        }));
      } else {
        setState((e) => ({
          ...e,
          products2: [
            {
              name: value.name,
              price: value.price,
              id: value.id,
              isDetailing: value.isDetailing,
              rdfCode: value.rdfCode,
              codes: value.codes,
              insuranceCode: value.insuranceCode,
              brandName: value.brandName,
              concentracionName: value.concentracionName,
              contentCant: value.contentCant,
              shapeName: value.shapeName,
              moleculeMedicines: value.moleculeMedicines,
            },
          ],
        }));
      }
      setState((e) => ({ ...e, show: true }));
    }
  };

  const loadMedicines = async (value, callback) => {
    if (value.length < 3) return callback([]);
    const {
      data: { items },
    } = await client.query({
      query: GET_MEDICINES,
      fetchPolicy: "network-only",
      variables: {
        where: {
          name: value,
          arsId: state.ars.arsId,
        },
      },
    });

    callback(
      uniqBy(items, "name").map((i) => ({
        id: i.id,
        name: i.name,
        isDetailing: i.isDetailing,
        nameDetailing: i.nameDetailing,
        price: i.price,
        retailPrice: i.retailPrice,
        rdfCode: i.rdfCode,
        codes: i.codes,
        insuranceCode: i.insuranceCode,
        brandName: i.brandName,
        concentracionName: i.concentracionName,
        contentCant: i.contentCant,
        shapeName: i.shapeName,
        moleculeMedicines: i.moleculeMedicines,
      }))
    );
  };

  const toggleModal = (modal) => {
    if (modal === "1") {
      setState((e) => ({ ...e, show: !e.show, showMessageError: false }));
      return;
    }
    setState((e) => ({ ...e, show2: !e.show2, showMessageError: false }));
  };

  const handleInputCount = (item, count) => {
    const newArray = state.products2.map((e) => {
      if (e.name === item.name) {
        e.value = e.price * count;
        e.count = count;
        return e;
      } else {
        return e;
      }
    });
    setState((e) => ({
      ...e,
      products2: newArray,
      key: item.name,
      showMessageError: count > 0 && false,
    }));
    // setTimeout(() => {
    //     ref2.current.focus();
    // }, 5)
  };

  const handleInputNewPrice = (item, newPrice) => {
    const newArray = state.products2.map((e) => {
      if (e.name === item.name) {
        e.oldPrice = typeof e.oldPrice !== "number" ? e.price : e.oldPrice;
        e.price = newPrice;
        e.value = e.count !== undefined ? e.count * newPrice : 0;
      }
      return e;
    });

    setState((e) => ({ ...e, products2: [...newArray], key: item.name }));
  };

  const resetPrices = (item) => {
    setState((current) => ({
      ...current,
      products2: resetProductPrice(current.products2, item),
    }));
  };

  const onResetForm = () => {
    setState((current) => ({
      ...initialState,
      arsList: current.arsList,
      reasonsCancelation: current.reasonsCancelation,
      recipeTypeOption: current.recipeTypeOption,
    }));
    setData({});
    setDataAuth({});
    setInputName("");
    setBranchSelected(null);
    setIsOpenPreautorizationModal(false);
  };

  const hasMoleculeDuplicated = (product) => {
    let product2 = [];
    state.products2.forEach((e) => {
      if (!isNaN(e.value)) product2.push(e);
    });

    const validator = product
      .map((p) => {
        return p.moleculeMedicines
          .map((molecule) => {
            if (
              product2[0].moleculeMedicines.some(
                (p2) =>
                  p2.moleculeId === molecule.moleculeId &&
                  p2.concentration.name === molecule.concentration.name
              )
            ) {
              // Validacion si es combinado producto tabla
              if (p.moleculeMedicines.length > 1) {
                // Validacion si es mono producto del modal
                if (product2[0].moleculeMedicines.length === 1) {
                  return {
                    // Retorna N : 1
                    existe: true,
                    productCombined: p.name,
                    molecule: molecule.molecule.name,
                    product: product2[0].name,
                    concentration: molecule.concentration.name,
                    concentrationUnit: molecule.concentrationUnit.name,
                    msg: 1,
                  };
                } // Retorna N : N
                return {
                  existe: true,
                  productCombined: p.name,
                  molecule: molecule.molecule.name,
                  product: product2[0].name,
                  concentration: molecule.concentration.name,
                  concentrationUnit: molecule.concentrationUnit.name,
                  msg: 2,
                };
              }
              // Validamos si es combinado producto modal y mono producto de la tabala
              if (
                product2[0].moleculeMedicines.length > 1 &&
                p.moleculeMedicines.length === 1
              ) {
                return {
                  // Producto modal combinado 1 : N
                  existe: true,
                  productCombined: product2[0].name,
                  molecule: product2[0].moleculeMedicines.find(
                    (m) => m.moleculeId === molecule.moleculeId
                  )?.molecule?.name,
                  product: p.name,
                  concentration: molecule.concentration.name,
                  concentrationUnit: molecule.concentrationUnit.name,
                  msg: 1,
                };
              }
              // 1 : 1
              return {
                existe: true,
                productCombined: p.name,
                molecule: product2[0].moleculeMedicines.find(
                  (m) => m.moleculeId === molecule.moleculeId
                )?.molecule?.name,
                product: product2[0].name,
                concentration: molecule.concentration.name,
                concentrationUnit: molecule.concentrationUnit.name,
                msg: 2,
              };
              // return true
            }

            return {
              existe: false,
            };
          })
          .filter((e) => e.existe);
      })
      .filter((e) => e.length);
    return validator.length ? validator[0]?.filter((e) => e.existe) : [];
  };

  const onAddProduct = async () => {
    try {
      setLoading(true);
      let product = [];
      let amountCero = false;
      state.products2.forEach((e) => {
        if (parseInt(e?.count) <= 0) {
          amountCero = true;
          setState((prev) => ({ ...prev, showMessageError: true }));
        }
        if (!isNaN(e.value)) product.push(e);
      });
      if (amountCero) return;
      const payload = preparePayload(product);

      const { data } = await client.query({
        query: MEDICINES_VALIDATION,
        fetchPolicy: "network-only",
        variables: {
          where: {
            arsId: state.ars.arsId,
            // planType: state.ars.arsId === 4? 1 : datas.planType, // Se le coloca uno solo para fines de prueba para Futuro
            planType: datas.planType,
            affiliatedId: datas.affiliateId,
            age: datas?.Age,
            medicines: payload[0],
            medicineValidationPlanList: datas.medicinePlanList,
          },
        },
      });

      // ! Validamos duplicidad de moleculas
      if (state.productSelected.length) {
        const hasMolecule = hasMoleculeDuplicated(state.productSelected); //Retorna boolean
        if (hasMolecule.length) {
          await client.query({
            query: MEDICINES_VALIDATION,
            fetchPolicy: "network-only",
            variables: {
              where: {
                arsId: state.ars.arsId,
                // planType: state.ars.arsId === 4? 1 : datas.planType, // Se le coloca uno solo para fines de prueba para Futuro
                planType: datas.planType,
                affiliatedId: datas.affiliateId,
                age: datas?.Age,
                medicines: payload[0],
                medicineValidationPlanList: datas.medicinePlanList,
                numImproperRequest: 13,
              },
            },
          });
          setState((e) => ({ ...e, show: false }));
          if (hasMolecule[0].msg === 1) {
            return addToast(
              `El producto ${hasMolecule[0].productCombined}, contiene la molécula ${hasMolecule[0].molecule} ${hasMolecule[0].concentration} ${hasMolecule[0].concentrationUnit}, por lo que el producto ${hasMolecule[0].product}, 
                        no puede ser dispensado en la misma receta, debe seleccionar el ${hasMolecule[0].productCombined} y eliminar el ${hasMolecule[0].product}`,
              { appearance: "error", autoDismiss: true }
            ); //Esto es para que no lo agregue
          }
          return addToast(
            `El producto ${hasMolecule[0].productCombined}, contiene la molécula ${hasMolecule[0].molecule} ${hasMolecule[0].concentration} ${hasMolecule[0].concentrationUnit}, por lo que el producto ${hasMolecule[0].product}, 
                    no puede ser dispensado en la misma receta.`,
            { appearance: "error", autoDismiss: true }
          ); //Esto es para que no lo agregue
        }
      }

      if (data.resp.errorCode === "500") {
        if (data.resp.requierePreautorizacion) {
          setState((e) => ({ ...e, show: false }));
          setIsOpenPreautorizationModal(true);
          return;
        }

        setState((e) => ({ ...e, show: false }));
        addToast(`${data.resp.errorMessage}. ${data.resp.observation}`, {
          appearance: "error",
          autoDismiss: true,
        });
        return;
      }

      setState((e) => ({
        ...e,
        productSelected: [...e.productSelected, ...product],
        show: false,
      }));
    } catch (error) {
      addToast(error.message, { appearance: "error", autoDismiss: true });
    } finally {
      setLoading(false);
    }
  };

  const onRemoveProduct = (id) => {
    const newArray = state.productSelected.filter((e) => e.id !== id);
    setState((e) => ({ ...e, productSelected: newArray }));
  };

  const onDispatchAuthorization = async () => {
    try {
      setState((e) => ({ ...e, loadingProcess: true }));
      const listMedicines = preparePayload(state.productSelected);
      const payload = {
        arsid: state.ars.arsId,
        affiliateContract: datas.affiliateContrat,
        pyPProgramCode: null, //Depende de la receta electronica. Por ahora se envia null
        phone: state.telephone,
        retireeId: state.cedPicker,
        authorizationId: 0,
        medicines: listMedicines,
        pSSSenderType: "Medico",
        senderPSSCode: null,
        senderPSSName: state.staff.label.trim(),
        interactionId: datas.interactionid,
        recipeDate: moment(state.recipeDate).format("yyyy-MM-DD"),
        doctorId: state.staff.value,
        senderCode: state.staff.code,
        diagnosticCode: "99999",
        patientId: datas.affiliateId,
        referralId: parseInt(state.referalNumber),
        affiliateToken: datas.Token,
        UUIDIdentifier: datas.UUIDIdentifier,
        // continuousPrescription: state.continuousPrescription,    //Se manda 0 por ahora
        continuousPrescription: state.isContinuousUse ? 1 : 0, //Se manda 0 por ahora
        seccionNumber: datas.seccionNumber,
        sessionIdPrimera: datas.sessionIdPrimera,
        branchId: branchSelected?.id,
        recipeId: state.recipeTypeSelected?.id,
      };

      const { data } = await updateMutate({
        variables: {
          data: payload,
        },
      });

      if (isEmpty(data.resp)) {
        addToast("La autorización no fue emitida correctamente.");
        return;
      }
      setDataAuth(data.resp);
      setState((e) => ({ ...e, loadingProcess: false, show2: !e.show2 }));
    } catch (error) {
      onError(error, addToast);
    } finally {
      setState((e) => ({ ...e, loadingProcess: false }));
    }
  };

  const preparePayload = (list) => {
    const listMedicines = list.map((e) => {
      if (e.isDetailing) {
        return {
          medicineId: e.id,
          code: e.codes,
          room: "0",
          amountDetails: e.count,
          concessionValue: 0,
          exceptionValue: 0,
          description: e.name,
          commercialCode: null,
          priceDetails: e.price,
          // medicineIdRDF: e.rdfCode,
          price: 0,
          amount: 0,
          insuranceCode: e.insuranceCode,
          brandName: e.brandName,
          concentracionName: e.concentracionName,
          contentCant: `${e.contentCant}`,
          shapeName: e.shapeName,
        };
      }
      return {
        medicineId: e.id,
        code: e.codes,
        room: "0",
        amount: e.count,
        concessionValue: 0,
        exceptionValue: 0,
        description: e.name,
        commercialCode: null,
        price: e.price,
        insuranceCode: e.insuranceCode,
        brandName: e.brandName,
        concentracionName: e.concentracionName,
        contentCant: `${e.contentCant}`,
        shapeName: e.shapeName,
        amountDetails: 0,
        priceDetails: 0,
        // medicineIdRDF: e.rdfCode
      };
    });
    return listMedicines;
  };

  const onCancelAuthorization = async (cancellationReason) => {
    try {
      if (state.ars.arsId === 17) {
        const payload = {
          arsid: state.ars.arsId,
          interactionId: datas.interactionid,
          authorizationNumber: dataAuth.claimnumber,
          cancellationReasonId: `${cancellationReason.id}`,
          cancellationReason: cancellationReason.description,
          claimId: dataAuth.claimId,
          codAuthorizationMonumental: dataAuth.codAuthorizationMonumental,
        };

        await cancelAuth({
          variables: {
            data: payload,
          },
        });
        return {
          ErrorNumber: 200,
          message: "Fue anulado la autorización!",
        };
      }

      const payload = {
        arsid: state.ars.arsId,
        interactionId: datas.interactionid,
        authorizationNumber: dataAuth.claimnumber,
        cancellationReasonId: `${cancellationReason.id}`,
        cancellationReason: cancellationReason.description,
        claimId: dataAuth.claimId,
      };

      const { data } = await cancelAuth({
        variables: {
          data: payload,
        },
      });

      if (isEmpty(data.resp)) {
        return {
          ErrorNumber: 500,
          message: "Ocurrió un error!",
        };
      }

      return data.resp;
      
    } catch (error) {
      addToast(error.message, { appearance: "error", autoDismiss: true });
    }
  };

  const reportOfferArs = async () => {
    try {
      const { offerSelected } = state;

      const grupos = Object.entries(
        offerSelected?.claimsOffersProcess?.reduce((acc, item) => {
          if (!acc[item.lineId]) acc[item.lineId] = [];
          acc[item.lineId].push(item);
          return acc;
        }, {})
      )?.map(([lineId, items]) => ({
        lineId: Number(lineId),
        items,
      }));

      if (!offerSelected?.claimsOffersProcess?.length)
        return addToast("No hay registros.", {
          appearance: "error",
          autoDismiss: true,
        });

      const companyInfo = await fetchCompanyInfo(client);

      for (const { items } of grupos)
        awardedOffersReportPdf(
          items,
          { fromDate: offerSelected.fromDate, toDate: offerSelected.toDate },
          offerSelected.nameOffer,
          companyInfo
        );

      setState((prev) => ({
        ...prev,
        offerSelected: {},
      }));
    } catch (error) {
      throw new Error(error.message);
    }
  };

  const handleReportPartialDispatch = async () => {
    try {
      reportPartialDispatch({
        infoBranchOffice: state.ars,
        infoPatient: datas,
        telephone: state?.telephone,
        nameRetire: state?.namePicker,
        loggedUserData
      });
    } catch (error) {
      addToast(error.message, { appearance: "error", autoDismiss: true });
    }
  };

  useEffect(() => {
    if (reasonCancelation && !isLoadingReasonCancelation) {
      setState((e) => ({
        ...e,
        reasonsCancelation: reasonCancelation.reasons,
      }));
    }
    if (branches && !loadingBranches) {
      setComboBranches(branches.branchesItems);
    }
  }, [
    reasonCancelation,
    isLoadingReasonCancelation,
    branches,
    loadingBranches,
  ]);

  useEffect(() => {
    if (arsList && !arsLoading) {
      setState((e) => ({
        ...e,
        arsList: arsList.arses.sort((a, b) => {
          if (a.arsName < b.arsName) return -1;
          if (a.arsName > b.arsName) return 1;

          return 0;
        }),
      }));
    }
  }, [arsList, arsLoading]);

  useEffect(() => {
    if (!loadingOptions && options) {
      setOptionsData(options);
    }
  }, [loadingOptions, options]);

  useEffect(() => {
    if (!isEmpty(offers) && !loadingOffers) {
      setState((prev) => ({
        ...prev,
        dataOffers: offers,
      }));

      if (!offers.length)
        addToast("Aseguradora no contiene Ofertas Registradas.", {
          appearance: "error",
          autoDismiss: true,
        });
    }
  }, [loadingOffers, addToast, offers]);

  return [
    {
      state,
      isLoading,
      isVerifyingRecipe,
      datas,
      dataAuth,
      isLoadingAffiliateUniversal,
      inputName,
      comboBranches,
      branchSelected,
      optionsData,
      isOpenPreautorizationModal
    },
    {
      onSelectArs,
      onResetForm,
      onSelectDoc,
      onHandleDoc,
      onVerifyAffiliate,
      handleStaffChange,
      loadMedicalStaffs,
      handleInputDate,
      handleInputs,
      onVerifyRecipeData,
      handleMedicineChange,
      loadMedicines,
      toggleModal,
      handleInputCount,
      handleInputNewPrice,
      resetPrices,
      onAddProduct,
      onRemoveProduct,
      onDispatchAuthorization,
      onCancelAuthorization,
      onSelectAffiliate,
      onCloseAffiliateModal,
      onHandleClickCedula,
      setInputName,
      onSaveWeirdIdentification,
      setBranchSelected,
      toggleDropDown,
      reportOfferArs,
      onChange,
      addToast,
      handleReportPartialDispatch,
      getLogo,
      setIsOpenPreautorizationModal
    },
  ];
};
